var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89082 17.8051C14.2014 17.8051 17.6957 14.3108 17.6957 10.0002C17.6957 5.68956 14.2014 2.19531 9.89082 2.19531C5.58018 2.19531 2.08594 5.68956 2.08594 10.0002C2.08594 11.8835 2.75325 13.6115 3.86389 14.9602L2.08594 17.8051H9.89082Z",
    stroke: "#1B5AF6",
    strokeWidth: 0.780488
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50098 8.48245V8.04849C7.50098 7.74101 7.56154 7.43653 7.67921 7.15246C7.79688 6.86838 7.96935 6.61026 8.18678 6.39283C8.4042 6.17541 8.66232 6.00293 8.9464 5.88526C9.23048 5.76759 9.53495 5.70703 9.84244 5.70703C10.1499 5.70703 10.4544 5.76759 10.7385 5.88526C11.0226 6.00293 11.2807 6.17541 11.4981 6.39283C11.7155 6.61026 11.888 6.86838 12.0057 7.15246C12.1233 7.43653 12.1839 7.74101 12.1839 8.04849V8.48245L9.84244 10.5632V11.9509",
    stroke: "#1B5AF6",
    strokeWidth: 0.780488
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84277 13.5127V14.6834",
    stroke: "#1B5AF6",
    strokeWidth: 0.780488
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.f1dc33c5.svg";
export { ForwardRef as ReactComponent };